import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginValidationsService } from 'src/app/auth/login-validations.service';
import { EncriptacionService } from 'src/app/services/encriptacion.service';
import { GeneralService } from 'src/app/services/general.service';
import { UsuarioService } from 'src/app/services/usuario.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-paciente',
  templateUrl: './paciente.component.html',
  styleUrls: ['./paciente.component.css']
})
export class PacienteComponent implements OnInit {

  _usuario: any = {};
  rut: '';
  tipo_usuario_name: string;



  generos: string[] = ['Masculino', 'Femenino', 'Prefiero no decirlo'];
  areaCodes: any[] = [];
  selectedAreaCode: any = { cou_phone_code: '56', cou_flag: 'fi-cl', cou_min_phone: 9, cou_max_phone: 9 };

  paises: any[] = [];
  regiones: any[] = [];
  comunas: any[] = [];

  pagina: any;


  public fieldTextType1: boolean = false;
  public fieldTextType2: boolean = false;
  public fieldTextType3: boolean = false;

  public signupPass: boolean = false;
  public signupPass1Focus: boolean = false;
  public signupPass2Focus: boolean = false;



  titulo: any = [
    "Actualiza tus datos personales",
    "Crea tu contraseña",
    "Reservar tu hora",
    "Tener videoconsultas",
    "Revisar tu historial de consultas",
    "Revisar tus datos personales",
    "Revisar tus beneficiarios"
  ];
  titulo2: any = [
    "¡Bienvenido!",
    "¡Bienvenido!",
    "Reservar tu hora en 4 simples pasos.",
    "Ir a la sala de espera y participar de la videollamada con tu médico ",
    "Ver el detalle de tus consultas y descargar los documentos generados.",
    "Editar tu perfil, agregar y eliminar beneficiarios ",
    "Editar tu perfil, agregar y eliminar beneficiarios "
  ];

  subtitulo: any = [
    "",
    "",
    "Selecciona el área médica o un médico/profesional específico.",
    "Selecciona sala de espera y conéctate en línea con tu médico/profesional.",
    "Para que tengas un registro de todas tus horas.",
    "En donde podrás editarlos y revisar tus antecedentes médicos.",
    "Para que lleves un registro de los vinculados a tu perfil."
  ];
  siguiente: any = [
    "Siguiente",
    "Siguiente",
    "Siguiente",
    "Siguiente",
    "Siguiente",
    "Siguiente",
    "¡Empezemos!"
  ];
  estilo: any = [
    '#E8E8E8',
    '#E8E8E8',
    '#E8E8E8',
    '#E8E8E8',
    '#E8E8E8',
    '#E8E8E8',
    '#E8E8E8',
  ]
  constructor(
    private router: Router,
    private GeneralService: GeneralService,
    public _usuarioService: UsuarioService,
    private fb: FormBuilder,
    private loginValidationsService: LoginValidationsService,

  ) { }

  ngOnInit(): void {
    this.updatePhoneValidators();

    // Verificar si hay un token en el sessionStorage
    if (!sessionStorage.getItem('token')) {
      this._usuarioService.logout();
      return; // Salir del método si no hay token
    }

    // Obtener información del usuario
    this._usuario = new EncriptacionService().getUserInfo();
    this.registerForm.controls['use_id'].setValue(this._usuario._id);

    this.rut = this._usuario.rut;
    this.tipo_usuario_name = this._usuario.typ_name;

    // Obtener información del perfil
    this._usuarioService.informacionPerfil(this.rut, this.tipo_usuario_name).subscribe(
      (data) => {
        // console.log('Información perfil:', data);
        this._usuario = data; // Asignar la información del perfil al usuario

        // Verificar los datos del perfil
        const datosIncompletos = this.verificarDatosIncompletos(this._usuario);

        // Ajustar la página según los datos incompletos
        if (datosIncompletos) {
          this.pagina = 0; // Redirigir a la página de completar datos
        } else if (this._usuario.use_password_default == true) {
          this.pagina = 1; // Redirigir a la página de configuración de contraseña
        } else if (this._usuario.use_onboarding == false) {
          this.pagina = 2; // Mostrar el onboarding normal
        }else{
          this.irDashboard();
        }
        this.limpiarColores();

        // Llenar el formulario con los valores del usuario
        if (this._usuario && this._usuario.rut) {
          const fechaNacimiento = this._usuario.fecha_nacimiento
            ? new Date(this._usuario.fecha_nacimiento).toISOString().split('T')[0]
            : null;
            // console.log(this._usuario.fecha_nacimiento);
            

          this.registerForm.patchValue({
            rut: this._usuario.rut,
            nombre: this._usuario.nombre,
            apellido_paterno: this._usuario.apellido_paterno,
            apellido_materno: this._usuario.apellido_materno,
            genero: this._usuario.genero,
            email: this._usuario.email,
            telefono: this._usuario.numero,
            fecha_nacimiento_chile: fechaNacimiento,
            //acceptTerms: this._usuario.terminos
          });
          // console.log(this.registerForm.value);
          
        }
      },
      (error) => {
        console.error('Error al obtener la información del perfil:', error);
      }
    );

    // Obtener códigos de países
    this._usuarioService.getCodPaises()
      .then((data: any) => {
        this.areaCodes = data as any[];
      })
      .catch(error => {
        console.error('Error al cargar los códigos de países:', error);
      });

    // Obtener países y regiones
    this._usuarioService.getPaises()
      .then(paises => {
        this.paises = paises as any[];
        this.registerForm.get('pais').valueChanges.subscribe(cou_id => {
          this._usuarioService.getRegiones(cou_id).then(regiones => {
            this.regiones = regiones as any[];
            this.comunas = [];
          }).catch(error => {
            console.error('Error al cargar las regiones:', error);
          });
        });
      })
      .catch(error => {
        console.error('Error al cargar los países:', error);
      });

    // Obtener comunas al cambiar la región
    this.registerForm.get('region').valueChanges.subscribe(reg_id => {
      this._usuarioService.getComunas(reg_id).then(comunas => {
        this.comunas = comunas as any[];
      }).catch(error => {
        console.error('Error al cargar las comunas:', error);
      });
    });
  }

  // Método para verificar datos incompletos
  private verificarDatosIncompletos(usuario: any): boolean {
    const camposObligatorios = [
      'nombre',
      'apellido_paterno',
      'genero',
      'fecha_nacimiento',
      'email',
      'numero',
      'idregion',
      'idcomuna',
      'calle',
      'numerocasa',
      //'use_accepted_terms_conditions'
    ];
  
    for (const campo of camposObligatorios) {
      if (!usuario[campo] || usuario[campo] === '' || usuario[campo] === '.-' || usuario[campo] === false) {
        console.warn(`Campo incompleto: ${campo}`);
        return true; // Retornar true si falta algún campo
      }
    }
  
    // Si todos los campos están completos, realiza la validación en la base de datos
    this.validarDatosUsuario();
  
    return false;
  }
  
  


  dropdownOpen: boolean = false;


  public registerForm = this.fb.group({

    // step1

    rut: [''],
    use_id: [''],
    nombre: ['', [Validators.required, Validators.minLength(3), Validators.pattern("^[a-zA-ZáéíóúÁÉÍÓÚñÑçÇ' ]+$")]],
    apellido_paterno: ['', [Validators.required, Validators.minLength(3), Validators.pattern("^[a-zA-ZáéíóúÁÉÍÓÚñÑçÇ' ]+$")]],
    apellido_materno: ['', [Validators.minLength(3), Validators.pattern("^[a-zA-ZáéíóúÁÉÍÓÚñÑçÇ' ]+$")]],
    genero: ['', Validators.required],
    fecha_nacimiento_chile: ['', [Validators.required, this.fechaNacimientoValidator]],
    //acceptTerms: [false, Validators.requiredTrue],

    // step2

    email: ['', [Validators.required, Validators.minLength(3),Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}(\\.[a-zA-Z]{2,})?$")]],
    codigo_area: [this.selectedAreaCode.cou_phone_code, Validators.required],
    telefono: ['', [Validators.required, Validators.pattern("^[0-9]*$")]],
    pais: ['', Validators.required],
    region: ['', Validators.required],
    comuna: ['', Validators.required],
    direccion: ['', Validators.required],
    numero: ['', [Validators.required, Validators.pattern('^(?=.*[0-9])[A-Za-z0-9]+$')]],
    rest: [''],
  })

  public cambiaPass = this.fb.group({
    contrasena_actual: ['', [Validators.required, Validators.pattern('(?=\\D*\\d)(?=[^a-z]*[a-z])(?=[^A-Z]*[A-Z]).{8,30}')]],
    contrasena_nueva: ['', [Validators.required, Validators.pattern('(?=\\D*\\d)(?=[^a-z]*[a-z])(?=[^A-Z]*[A-Z]).{8,30}')]],
    contrasena_nueva_2: ['', [Validators.required, Validators.pattern('(?=\\D*\\d)(?=[^a-z]*[a-z])(?=[^A-Z]*[A-Z]).{8,30}')]],
    // codigo_verificacion: [''],
  }, {
    validators: this.passwordsIguales('contrasena_nueva', 'contrasena_nueva_2')
  });


  fechaNacimientoValidator(control: AbstractControl): ValidationErrors | null {
    const fechaIngresada = new Date(control.value); // Fecha ingresada por el usuario
    const fechaActual = new Date(); // Fecha actual

    // Si no hay valor ingresado, no aplica validación
    if (!control.value) {
        return null;
    }

    // Comparar la fecha ingresada con la fecha actual
    if (fechaIngresada > fechaActual) {
        return { añoInvalido: true }; // Fecha inválida: no puede ser futura
    }

    return null; // Fecha válida
}


  selectAreaCode(areaCode: any) {
    this.selectedAreaCode = areaCode;
    this.registerForm.get('codigo_area').setValue(areaCode.cou_phone_code);

    const telefonoControl = this.registerForm.get('telefono');
    const fullPhoneNumber = `${areaCode.cou_phone_code}${telefonoControl.value}`;

    // console.log(fullPhoneNumber);

    this.updatePhoneValidators();
    this.closeDropdown();  // Cierra el dropdown después de seleccionar
  }

  updatePhoneValidators() {
    const telefonoControl = this.registerForm.get('telefono');
    telefonoControl.setValidators([
      Validators.required,
      Validators.minLength(this.selectedAreaCode.cou_min_phone),
      Validators.maxLength(this.selectedAreaCode.cou_max_phone),
      Validators.pattern("^[0-9]*$")
    ]);
    telefonoControl.updateValueAndValidity();
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  closeDropdown() {
    this.dropdownOpen = false;
  }

  formSubmitted: boolean = false;
  formSubmitted2: boolean = false;

   campoNoValido(campo: string) {
    const control = this.registerForm.get(campo);
    return control?.invalid && (control?.touched || this.formSubmitted);
  }


  onSubmit() {
    if (this.registerForm.valid) {
      this.formSubmitted = true;
      // Lógica de envío del formulario
      // console.log('Formulario enviado con éxito', this.registerForm.value);
    } else {
      // console.log('Formulario inválido');
    }
  }

  volverBoton() {

    this.pagina = this.pagina - 1;
    this.limpiarColores();
    // console.log(this.pagina);

  }

  salirBoton() {
    if (this.pagina <= 2) {
      this._usuarioService.logout();
    }

  }
  omitirBoton() {
    this.irDashboard(); 
  }

  irDashboard() {
    this.router.navigate(['dashboard']) //navigateByUrl('/dashboard');
    setTimeout(() => window.location.reload(), 1000);
  }
  siguienteBoton() {
    if (this.pagina === 0) {
      this.modificarDatos();
      this.validarDatosUsuario();
  
      if (this._usuario.use_onboarding === true && this._usuario.use_password_default === false) {
        this.empezemosBoton();
      }
    } else if (this.pagina === 1) {
      this.cambiaPassword()
        .then(() => {
          // console.log('Contraseña cambiada correctamente. Ejecutando postSetPasswordDefault.');
          return this.postSetPasswordDefault(); // Ejecuta solo si cambiaPassword fue exitoso
        })
        .then(() => {
          // console.log('postSetPasswordDefault completado. Verificando onboarding...');
          if (this._usuario.use_onboarding === true) {
            this.empezemosBoton();
          }
          this.pagina = this.pagina + 1;
        })
        .catch((error) => {
          console.error('Error en el flujo:', error);
        });
    } else {
      this.pagina = this.pagina + 1;
      this.limpiarColores();
    }
  }
  
  

  validarDatosUsuario() {
    try {
      const response = this.GeneralService.postValidaDatosUsuario();
      // console.log('Respuesta del backend:', response);

     
    } catch (error) {
      console.error('Error al validar los datos del usuario:', error);
    }
  }
  postSetPasswordDefault() {
    try {
      const response = this.GeneralService.postSetPasswordDefault();
      // console.log('Respuesta del backend:', response);

     
    } catch (error) {
      console.error('Error al validar los datos del usuario:', error);
    }
  }




  modificarDatos() {
    this.formSubmitted = true;
  
    if (this.registerForm.invalid) {
      // Mostrar mensaje de error si el formulario es inválido
      Swal.fire({
        html: `
          <div style="margin: 40px 0;">
            <i class="material-icons" style="color:#2BABB7; font-size: 58px; margin-bottom:25px">error_outline</i>
            <h1 style="font-family: Mulish; font-style: normal; font-weight: 700; font-size: 24px; line-height: 32px; text-align: center; color: #171994;">Hubo un error al enviar los datos.</h1>
          </div>
        `,
        showConfirmButton: false,
        timer: 3000,
      });
      return;
    }
  
    // Mostrar mensaje de carga
    Swal.fire({
      allowOutsideClick: false,
      html: `
        <div style="margin: 40px 0;">
          <i class="material-icons" style="color:#2BABB7; font-size: 58px; margin-bottom:25px">schedule</i>
          <h1 style="font-family: Mulish; font-style: normal; font-weight: 700; font-size: 24px; line-height: 32px; text-align: center; color: #171994;">Cargando</h1>
        </div>
      `,
      showConfirmButton: false,
      timer: 2000,
    });
  
    // Preparar el número de teléfono
    const codigoArea = this.registerForm.value.codigo_area || this.selectedAreaCode?.cou_phone_code || '';
    const telefono = `+${codigoArea}${this.registerForm.value.telefono}`;
  
    // Preparar datos para enviar
    const dataParaEnviar = {
      ...this.registerForm.value,
      telefono,
    };
  
    // Enviar datos al servicio
    this._usuarioService.modificarUsuario(dataParaEnviar)
      .then((data: any) => {
        // Mostrar mensaje de éxito
        Swal.fire({
          allowOutsideClick: false,
          html: `
            <div style="margin: 40px 0;">
              <i class="material-icons" style="color:#171994; font-size: 58px; margin-bottom:25px">mood</i>
              <h1 style="font-family: Mulish; font-style: normal; font-weight: 800; font-size: 38px; line-height: auto; text-align: center; color: #171994; margin-bottom:25px;">
                Tus datos han sido guardados con éxito
              </h1>
            </div>
          `,
          showConfirmButton: false,
          timer: 3000,
        }).then(() => {
          // Determinar la próxima página
          if ( this._usuario.use_password_default || this._usuario.x === 'no') {
            this.pagina = 1; // Página de configuración de contraseña
          } else if (this._usuario.use_onboarding === false) {
            this.pagina = 2; // Página de onboarding
          } else {
            this.irDashboard(); // Ir al dashboard
            return;
          }
  
          // Actualizar colores y avanzar
          this.limpiarColores();
          // console.log(`Página actual: ${this.pagina}`);
        });
      })
      .catch((error) => {
        console.error('Error al enviar los datos', error);
  
        // Mostrar mensaje de error
        Swal.fire({
          allowOutsideClick: false,
          html: `
            <div style="margin: 40px 0;">
              <i class="material-icons" style="color:#2BABB7; font-size: 58px; margin-bottom:25px">error_outline</i>
              <h1 style="font-family: Mulish; font-style: normal; font-weight: 700; font-size: 24px; line-height: 32px; text-align: center; color: #171994;">Hubo un error al enviar los datos.</h1>
            </div>
          `,
          showConfirmButton: false,
          timer: 3000,
        });
      });
  }
  

  toggleFieldTextType1 = () => {
    this.fieldTextType1 = !this.fieldTextType1;
  }

  toggleFieldTextType2 = () => {
    this.fieldTextType2 = !this.fieldTextType2;
  }
  toggleFieldTextType3 = () => {
    this.fieldTextType3 = !this.fieldTextType3;
  }

  passLength: number = 0;
  passMinLength: boolean = false;
  passCapital: boolean = false;
  passLetter: boolean = false;
  passNumber: boolean = false;
  equalPass: boolean = false;
  contrasena_nueva_2: string;

  checkPass1 = () => {
    const pass1: string = this.cambiaPass.get('contrasena_nueva').value;
    this.passLength = pass1.length;
    if (this.passLength >= 8) {
      this.passMinLength = true;
    } else {
      this.passMinLength = false;
    }
    if (pass1.match(/[A-Z]/g)) {
      this.passCapital = true;
    } else {
      this.passCapital = false;
    }
    if (pass1.match(/[a-z]/g)) {
      this.passLetter = true;
    } else {
      this.passLetter = false;
    }
    if (pass1.match(/[0-9]/g)) {
      this.passNumber = true;
    } else {
      this.passNumber = false;
    }
  }

  campoNoValidoPassword(campo: string): boolean {

    if (this.cambiaPass.get(campo) != this.cambiaPass.get('contrasena_nueva') && this.formSubmitted2) { // si el campo no es valido y se apreto el boton postear me retorna un true y muestra el mensaje de errro
      return true;
    } else {
      return false;
    }
  }

  cambiaPassword(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.formSubmitted2 = true;
  
      if (this.cambiaPass.invalid) {
        console.error('Formulario inválido');
        return reject('Formulario inválido');
      }
  
      Swal.fire({
        allowOutsideClick: false,
        html: `
          <div style="margin: 40px 0;">
            <i class="material-icons" style="color:#2BABB7; font-size: 58px; margin-bottom:25px">schedule</i>
            <h1 style="font-family: Mulish; font-style: normal; font-weight: 700; font-size: 24px; line-height: 32px; text-align: center; color: #171994;">Espere por favor...</h1>
          </div>`,
        showConfirmButton: false,
        timer: 3000,
      });
  
      this._usuarioService.modificarPassword(this.cambiaPass.value).subscribe(
        (data: any) => {
          if (data.status) {
            // console.log('Contraseña cambiada correctamente.');
            Swal.fire({
              allowOutsideClick: false,
              html: `
                <i class="material-icons" style="color:#171994;font-size: 58px;margin: 20px 40px 10px;">mood</i> <br><br>
                <h1 style="font-family: Mulish; font-style: normal; font-weight: 800;font-size: 28px; line-height: auto; align-items: center; text-align: center; color: #171994;">La contraseña ha sido modificada exitosamente</h1> <br>
                <p style="font-family: Mulish; font-style: normal; font-weight: normal; font-size: 18px; line-height: 24px; text-align: center; color: #000000;"></p><br>`,
              showConfirmButton: false,
              timer: 3000,
            });
            resolve();
          } else {
            console.error('Error en la respuesta del backend:', data.message);
            Swal.fire({
              allowOutsideClick: false,
              html: `
                <i class="material-icons" style="color:#171994;font-size: 58px;margin: 20px 40px 10px;">mood_bad</i> <br><br>
                <h1 style="font-family: Mulish; font-style: normal; font-weight: 800;font-size: 28px; line-height: auto; align-items: center; text-align: center; color: #171994;">${data.message}</h1> <br>
                <p style="font-family: Mulish; font-style: normal; font-weight: normal; font-size: 18px; line-height: 24px; text-align: center; color: #000000;"></p><br>`,
              showConfirmButton: true,
            });
            reject(data.message);
          }
        },
        (err) => {
          console.error('Error en la llamada al servicio:', err);
          Swal.fire({
            allowOutsideClick: false,
            html: `
              <i class="material-icons" style="color:#171994;font-size: 58px;margin: 20px 40px 10px;">mood_bad</i> <br><br>
              <h1 style="font-family: Mulish; font-style: normal; font-weight: 800;font-size: 28px; line-height: auto; align-items: center; text-align: center; color: #171994;">${err.error.message || 'Error desconocido'}</h1> <br>
              <p style="font-family: Mulish; font-style: normal; font-weight: normal; font-size: 18px; line-height: 24px; text-align: center; color: #000000;">Intente nuevamente.</p><br>`,
          });
          reject(err.error.message || 'Error desconocido');
        }
      );
    });
  }
  
  
  

  passwordsIguales(pass1Name: string, pass2Name: string) {
    return (formGroup: FormGroup) => {
      this.formSubmitted2 = false;
      const pass1Control = formGroup.get(pass1Name);
      const pass2Control = formGroup.get(pass2Name);
      if (pass1Control.value !== pass2Control.value) {
        return {
          noEsIgual: true
        };
      }
    }
  }




  empezemosBoton() {
    // this.pagina = this.pagina + 1;

    this.GeneralService.postRealizaOnBoarding()
      .then(result => {
        //console.log(result);
        this.irDashboard();
      })
      .catch(error => {
        console.log(error);
        this.irDashboard();
      })

  }

  limpiarColores() {
    this.estilo = [
      '#E8E8E8',
      '#E8E8E8',
      '#E8E8E8',
      '#E8E8E8',
      '#E8E8E8',
      '#E8E8E8',
      '#E8E8E8',
    ];

    if (this.pagina <= 6) {
      this.estilo[this.pagina] = '#2AC9CE';
    } else {
      this.estilo[4] = '#2AC9CE';
    }
  }

}

